import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { revealText } from '~/plugins/animation-directives/reveal-text.js'

export default defineNuxtPlugin((nuxtApp) => {
  // Reveal Text
  nuxtApp.vueApp.directive('anim-reveal-text', {
    mounted(el) {
      revealText(el)
    },
  })
})
